import { FileUploader } from "ng2-file-upload";

export function initUploader(url: string, token: string, maxFileSize: number, allowedMimeType: string[]): FileUploader {
  return new FileUploader({
    url,
    isHTML5: true,
    headers: [{
      name: 'Authorization',
      value: `Bearer ${token}`,
    }],
    maxFileSize,
    allowedMimeType
  });
}

export function formatBytes(bytes: number, decimals?: number) {
  if (bytes == 0) return '0 Bytes';
  const k = 1024,
    dm = decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
